import { render } from "./MediaCollection.vue?vue&type=template&id=dbc08e22"
import script from "./MediaCollection.vue?vue&type=script&lang=js"
export * from "./MediaCollection.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__